//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        display: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
        },
        message: {
            type: String,
        },
    },
    data() {
        return {
            confirm: false,
        }
    },
    watch: {
        display: function() {
            this.confirm = !this.confirm
        },
    },
    methods: {
        sendAccept() {
            this.$emit('accept')
        },
        sendCancel() {
            this.$emit('cancel')
        },
    },
}
